// Helper function to detect OS and return appropriate save hint
export const getSaveHint = (): string => {
  const isMac = navigator.platform.toUpperCase().indexOf('MAC') >= 0 || navigator.userAgent.toUpperCase().indexOf('MAC') >= 0
  return isMac ? 'Command + Return To Save' : 'Control + Enter To Save'
}

/** Show literal "degree" before "in" when the degree field does not already include that word. */
export function showDegreeConnectorWord(degree: string): boolean {
  return !/\bdegree\b/i.test(degree.trim())
}
